import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledCalendarMonthProps } from './SimpleCalendar.types';

export const StyledArrow = styled.span<{ left?: boolean; noHover?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('20px')};
  height: ${rem('20px')};
  margin-left: ${rem('8px')};
  cursor: ${({ noHover }) => !noHover && `pointer`};

  & svg {
    width: ${rem('11px')};
    height: auto;
    position: absolute;
    transform: ${({ left }) => (left ? 'rotate(90deg)' : 'rotate(-90deg)')};
  }
`;

export const StyledCalendarContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 25%);
  grid-gap: 1px;
  background-color: ${({ theme }) => theme.colors.cross.lightGray};
  border: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
  border-radius: ${rem('8px')};
  overflow: hidden;
`;

export const StyledCalendarMonth = styled.div<IStyledCalendarMonthProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  font-size: ${rem('12px')};
  height: ${rem('40px')};
  padding: 0;
  cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};
  color: ${({ selected, user, theme }) =>
    selected ? theme.colors[user].main : theme.colors.cross.grayson};
  background-color: ${({ selected, user, theme }) =>
    selected ? theme.colors[user].mainPale : theme.colors.main};

  &:hover {
    color: ${({ selected, user, theme }) =>
      selected ? theme.colors[user].main : theme.colors.cross.black};
    background-color: ${({ theme, selected }) =>
      !selected && theme.colors.cross.ultralightGray};
  }
`;

export const StyledYearContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${rem('12px')} 0;
  font-size: ${rem('12px')};
  user-select: none;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
